import { defineComponent } from 'vue-demi';
import { observer } from '@formily/reactive-vue';
import { useForm } from '../hooks';
import h from '../shared/h';
export default observer(defineComponent({
    name: 'FormConsumer',
    inheritAttrs: false,
    setup: function (props, _a) {
        var slots = _a.slots;
        var formRef = useForm();
        return function () {
            // just like <Fragment>
            return h('div', { style: { display: 'contents' } }, {
                default: function () {
                    var _a;
                    return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots, {
                        form: formRef.value,
                    });
                },
            });
        };
    },
}), {
    // make sure observables updated <cannot be tracked by tests>
    scheduler: /* istanbul ignore next */ function (update) {
        return Promise.resolve().then(update);
    },
});
//# sourceMappingURL=FormConsumer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/components/FormConsumer.js
// module id = null
// module chunks = 